export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL?.trim() || 'https://photosapi.shicks255.com'
).replace(/\/+$/, '');
